import React, {memo, useCallback, useState, useMemo, useEffect} from "react"
import {PasswordContainer} from "../../../../../../components/PasswordContainer"
import {SettingsPageContainer} from "../../../../../../components/Settings/SettingsPageContainer"
import {useRPC} from "../../../../../../hooks/rpc"
import {useSelector} from "react-redux"
import {SettingSelectComponent} from "../../../../../../components/Settings/SettingSelectComponent"
import {SelectItem} from "../../../../../../components/Select"
import {SettingInputComponent} from "../../../../../../components/Settings/SettingInputComponent"
import {useKeyboard} from "../../../../../../hooks/keyboard"
import {useMessage} from "../../../../../../hooks/message"
import "./index.scss"

export const PingTestScreen = memo(function PingTestScreen() {
    const ping = useSelector(state => state.control.pingTest)
    const [manualAddress, setManualAddress] = useState("")
    const [setActiveInput, renderKeyboard] = useKeyboard()
    const [pingResult, setPingResult] = useState<string[]>([])
    const {failure} = useMessage()
    const [rpc] = useRPC()
    const DEFAULT_ADDRESS_LIST = useMemo<SelectItem<string>[]>(
        () => [
            {
                value: "google.com",
                label: "google"
            },
            {
                value: "inohom.com",
                label: "inohom"
            },
            {
                value: "8.8.8.8",
                label: "8.8.8.8"
            },
            {
                value: "1.1.1.1",
                label: "1.1.1.1"
            },
            {
                value: "manual",
                label: "Manuel"
            }
        ],
        []
    )
    const [addressSelect, setAddressSelect] = useState<SelectItem<string>>(
        DEFAULT_ADDRESS_LIST.find(pingTest => pingTest.value) || null
    )

    const onBlur = useCallback(() => setActiveInput(null), [setActiveInput])

    const startTest = useCallback(
        (address: string) => {
            if (addressSelect == null) {
                failure("Lütfen geçerli bir adres giriniz.")
                return
            }
            if (addressSelect?.value === "manual" && manualAddress.length === 0) {
                failure("Lütfen geçerli bir adres giriniz.")
                return
            }
            setPingResult([])
            rpc.SendTestPing(address)
        },
        [failure, rpc, addressSelect, manualAddress]
    )

    const buttons = useMemo(
        () => [
            {
                text: "Ping Testini Başlat",
                className: "blue",
                onClick: () => startTest(addressSelect?.value === "manual" ? manualAddress : addressSelect?.value)
            }
        ],
        [startTest, addressSelect, manualAddress]
    )

    useEffect(() => {
        setPingResult(prev => [...prev, ping])
    }, [ping])
    return (
        <PasswordContainer requiredRole="service" isFullscreen={true}>
            <SettingsPageContainer
                buttons={buttons}
                className="service-edit"
                backUrl={"/settings/advanced-settings/test/network"}
            >
                <div className="content-divider">
                    <div className="content-wrapper">
                        <SettingSelectComponent
                            label="Adres Listesi"
                            options={DEFAULT_ADDRESS_LIST}
                            onChange={setAddressSelect}
                            value={addressSelect}
                        />
                        {renderIf(addressSelect?.value === "manual")(() => (
                            <SettingInputComponent
                                placeholder={"Adres giriniz..."}
                                label={"Adres Adı"}
                                value={manualAddress}
                                setValue={setManualAddress}
                                setActiveInput={setActiveInput}
                                onBlur={onBlur}
                            />
                        ))}
                    </div>
                    <div className="content-wrapper">
                        <div className="network-result-container">
                            {pingResult.map((r, i) => (
                                <span key={i}>{r}</span>
                            ))}
                        </div>
                    </div>
                </div>
            </SettingsPageContainer>
            {renderKeyboard()}
        </PasswordContainer>
    )
})
